import { AxiosInstance, AxiosStatic } from "axios";
import { AxiosHookInjector } from "../types";
import { AxiosPluginHook } from "../types";
import { AxiosHandlerType } from "../../types";

export class AxiosHttpHookHandler {
  constructor(public use: (hook: AxiosPluginHook) => void) {}
  pipe(hooks: AxiosPluginHook[]) {
    return hooks.map(hook => this.use(hook));
  }
}

export class AxiosHookManager {
  constructor(
    protected axios: AxiosInstance | AxiosStatic,
    public inject: AxiosHookInjector
  ) {}

  use(hook: AxiosPluginHook) {
    this.request.use(hook);
    this.response.use(hook);
  }

  useResponseHook(hook: AxiosPluginHook) {
    return this.inject({
      axios: this.axios,
      type: AxiosHandlerType.response,
      hook
    });
  }
  useRequestHook(hook: AxiosPluginHook) {
    return this.inject({
      axios: this.axios,
      type: AxiosHandlerType.request,
      hook
    });
  }

  response = new AxiosHttpHookHandler(this.useResponseHook.bind(this));
  request = new AxiosHttpHookHandler(this.useRequestHook.bind(this));
}
